(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nata-home-locator"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nata-home-locator]').forEach((section) => {
    const button = section.querySelector('[data-use-location]');
    const map = section.querySelector('[data-map]');
    if (!button || !map) return;
    button.addEventListener('click', () => {
      if (!navigator.geolocation) { window.location.href = '/pages/where-to-buy'; return; }
      button.disabled = true;
      button.textContent = 'Finding...';
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const query = encodeURIComponent(`Nata Portuguese Bakery stockists near ${position.coords.latitude},${position.coords.longitude}`);
          map.src = `https://www.google.com/maps?q=${query}&output=embed`;
          button.disabled = false;
          button.textContent = 'Use my location';
        },
        () => { button.disabled = false; button.textContent = 'Use my location'; window.location.href = '/pages/where-to-buy'; },
        { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 }
      );
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nata-stockist-map"] && !Shopify.designMode) return;
  try {
    
  class NataEditableStockistMap {
    constructor(section) {
      this.section = section;
      this.search = section.querySelector('[data-stockist-search]');
      this.region = section.querySelector('[data-stockist-region]');
      this.list = section.querySelector('[data-stockist-list]');
      this.count = section.querySelector('[data-stockist-count]');
      this.selected = section.querySelector('[data-stockist-selected]');
      this.map = section.querySelector('[data-stockist-map]');
      this.cards = [...section.querySelectorAll('[data-stockist-card]')];
      this.active = this.cards[0];
      this.setup();
      this.render();
    }

    setup() {
      const regions = [...new Set(this.cards.map((card) => card.dataset.region).filter(Boolean))].sort();
      regions.forEach((region) => {
        const option = document.createElement('option');
        option.value = region;
        option.textContent = region;
        this.region.append(option);
      });
      this.cards.forEach((card) => card.addEventListener('click', () => { this.active = card; this.render(); this.map.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }));
      this.search.addEventListener('input', () => this.render());
      this.region.addEventListener('change', () => this.render());
    }

    render() {
      const query = this.search.value.trim().toLowerCase();
      const region = this.region.value;
      let visible = 0;
      this.cards.forEach((card) => {
        const haystack = `${card.dataset.name} ${card.dataset.address} ${card.dataset.region} ${card.dataset.type}`.toLowerCase();
        const match = (region === 'all' || card.dataset.region === region) && (!query || haystack.includes(query));
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (!this.active || this.active.hidden) this.active = this.cards.find((card) => !card.hidden);
      this.count.textContent = `${visible} stockist${visible === 1 ? '' : 's'} found`;
      this.cards.forEach((card) => card.setAttribute('aria-selected', card === this.active ? 'true' : 'false'));
      if (!visible) {
        this.selected.innerHTML = '<div class="nata-stockists-map__empty">No stockists match that search.</div>';
        return;
      }
      this.updateMap(this.active);
    }

    updateMap(card) {
      if (!card) return;
      const query = encodeURIComponent(card.dataset.fullAddress || card.dataset.address || card.dataset.name);
      this.map.src = `https://www.google.com/maps?q=${query}&output=embed`;
      this.selected.innerHTML = `<div><strong>${this.escape(card.dataset.name)}</strong><span>${this.escape(card.dataset.fullAddress || card.dataset.address)}</span></div><a class="nata-stockists-map__directions" href="https://www.google.com/maps/search/?api=1&query=${query}" target="_blank" rel="noopener">Directions</a>`;
    }

    escape(value) {
      return String(value || '').replace(/[&<>"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[character]);
    }
  }

  document.querySelectorAll('[data-nata-stockists-map]').forEach((section) => new NataEditableStockistMap(section));

  } catch(e) { console.error(e); }
})();
})();
